'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseHubsData = undefined;

var _HubsDataActionTypes = require('../actionTypes/HubsDataActionTypes');

var _actionWithPayload = require('../utils/actionWithPayload');

var _actionWithPayload2 = _interopRequireDefault(_actionWithPayload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parseHubsData = exports.parseHubsData = function parseHubsData(query) {
  return (0, _actionWithPayload2.default)(_HubsDataActionTypes.HUBS_DATA_FETCHED, query);
};